export const storyPreviewMessages = {
  noSpreadAvailable: 'No preview available',
  spreadIndicator: (current: number, total: number) => `${current} of ${total}`,
  checkoutTitle: 'The rest of your story awaits!',
  checkoutMessage:
    'Checkout now by clicking the button below to access your entire story',
  celebration: 'celebration',
} as const;
